<div *ngIf="home">
    <mat-card class="yulava-container" style="padding: 0px;">

        

        <mat-card-title style="background-color:#fff;color:#0f0f0f;width:100%;border-radius: var(--client-radius) var(--client-radius)  0px 0px;padding: 8px 0px 8px 0px;font-size: 16px;">
            <a href="https://connect.yulava.com/" target="new">
                <img src="{{environment.assetsUrl}}assets/images/yulava_negro.png" class="yulava-logo" title="logo Yulava" alt="logo Yulava">
            </a>
            <br>
            {{ 'general.member_club' | translate }}
        </mat-card-title>
        <mat-card-actions style="margin:  0px;margin-top:10px">
            
            <a href="https://connect.yulava.com/" target="new">
                <button mat-flat-button>{{ 'general.access' | translate }}</button>
            </a>
        </mat-card-actions>
        <div class="text-center" style="width: 100%;padding: 20px 8px 8px 8px;">
            <mat-card-subtitle style="margin-bottom: 8px;">{{ 'general.download_app' | translate }}</mat-card-subtitle>
            <div style="display: flex; justify-content: center;">
                <a href="https://play.google.com/store/apps/details?id=com.yulava.connect" target="new" class="app-store-logo">
                    <img src="{{environment.assetsUrl}}assets/icons/android.svg" title="Google Play" alt="Google Play">
                </a>
                <a href="https://apps.apple.com/es/app/yulava-connect/id1533240784" target="new" class="app-store-logo">
                    <img src="{{environment.assetsUrl}}assets/icons/ios.svg" title="App Store" alt="App Store">
                </a>
            </div>
        </div>
    </mat-card>
</div>